import React from "react";
import styled from "styled-components";

export const UIList = ({ items, children, ...props }) => {
  return (
    <Wrapper {...props}>
      {items.map(
        (item, ind) =>
          children && React.cloneElement(children(item, ind), { key: ind })
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  -webkit-overflow-scrolling: touch;
`;

export const UIGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ template }) => template};
  gap: ${({ gap }) => gap};
  ${(props) => {
    let customCss = "";
    const keys = Object.keys(props);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key.match(/template-/)) {
        const temp = key.split("-");
        customCss =
          customCss +
          `@media only screen and (max-width: ${temp[1]}) {
              grid-template-columns: ${props[key]};
              ${temp[2] && `gap: ${temp[2]};`}
            }          
          `;
        delete props[key];
      }
    }
    return customCss;
  }}
`;
